(() => {
customElements.get("quick-add-modal")||customElements.define("quick-add-modal",class extends ModalDialog{constructor(){super(),this.modalContent=this.querySelector('[id^="QuickAddInfo-"]'),this.addEventListener("product-info:loaded",({target})=>{target.addPreProcessCallback(this.preprocessHTML.bind(this))})}hide(preventFocus=!1){const cartNotification=document.querySelector("cart-notification")||document.querySelector("cart-drawer");cartNotification&&cartNotification.setActiveElement(this.openedBy),this.modalContent.innerHTML="",preventFocus&&(this.openedBy=null),super.hide()}show(opener){opener.setAttribute("aria-disabled",!0),opener.classList.add("loading"),opener.querySelector(".loading__spinner").classList.remove("hidden"),fetch(opener.getAttribute("data-product-url")).then(response=>response.text()).then(responseText=>{const productElement=new DOMParser().parseFromString(responseText,"text/html").querySelector("product-info");this.preprocessHTML(productElement),HTMLUpdateUtility.setInnerHTML(this.modalContent,productElement.outerHTML),window.Shopify&&Shopify.PaymentButton&&Shopify.PaymentButton.init(),window.ProductModel&&window.ProductModel.loadShopifyXR(),this.modalContent.querySelector("product-component")?.dispatchViewEvent?.(),super.show(opener)}).finally(()=>{opener.removeAttribute("aria-disabled"),opener.classList.remove("loading"),opener.querySelector(".loading__spinner").classList.add("hidden")})}preprocessHTML(productElement){productElement.classList.forEach(classApplied=>{(classApplied.startsWith("color-")||classApplied==="gradient")&&this.modalContent.classList.add(classApplied)}),this.preventDuplicatedIDs(productElement),this.removeDOMElements(productElement),this.removeGalleryListSemantic(productElement),this.updateImageSizes(productElement),this.preventVariantURLSwitching(productElement)}preventVariantURLSwitching(productElement){productElement.setAttribute("data-update-url","false")}removeDOMElements(productElement){const pickupAvailability=productElement.querySelector("pickup-availability");pickupAvailability&&pickupAvailability.remove();const productModal=productElement.querySelector("product-modal");productModal&&productModal.remove();const modalDialog=productElement.querySelectorAll("modal-dialog");modalDialog&&modalDialog.forEach(modal=>modal.remove())}preventDuplicatedIDs(productElement){const sectionId=productElement.dataset.section,oldId=sectionId,newId=`quickadd-${sectionId}`;productElement.innerHTML=productElement.innerHTML.replaceAll(oldId,newId),Array.from(productElement.attributes).forEach(attribute=>{attribute.value.includes(oldId)&&productElement.setAttribute(attribute.name,attribute.value.replace(oldId,newId))}),productElement.dataset.originalSection=sectionId}removeGalleryListSemantic(productElement){const galleryList=productElement.querySelector('[id^="Slider-Gallery"]');galleryList&&(galleryList.setAttribute("role","presentation"),galleryList.querySelectorAll('[id^="Slide-"]').forEach(li=>li.setAttribute("role","presentation")))}updateImageSizes(productElement){const product=productElement.querySelector(".product");if(!product?.classList.contains("product--columns"))return;const mediaImages=product.querySelectorAll(".product__media img");if(!mediaImages.length)return;let mediaImageSizes="(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";product.classList.contains("product--medium")?mediaImageSizes=mediaImageSizes.replace("715px","605px"):product.classList.contains("product--small")&&(mediaImageSizes=mediaImageSizes.replace("715px","495px")),mediaImages.forEach(img=>img.setAttribute("sizes",mediaImageSizes))}});const bindBaskoCartSlide=()=>{const slide=document.querySelector(".xboost-cart-slide");if(slide&&(slide.dataset.baskoQuickCartObserved!=="true"&&(slide.dataset.baskoQuickCartObserved="true",new MutationObserver(()=>{slide.dataset.baskoQuickCartForced==="true"&&slide.style.display==="none"&&(delete slide.dataset.baskoQuickCartForced,document.documentElement.removeAttribute("data-basko-quick-cart-open"))}).observe(slide,{attributes:!0,attributeFilter:["style"]})),document.documentElement.getAttribute("data-basko-quick-cart-open")==="true")){slide.dataset.baskoQuickCartForced="true",slide.style.display="flex",slide.style.zIndex="2147483647",slide.style.flexDirection="row";const drawer=slide.querySelector(".xb-cart-drawer-wrapper");drawer&&(drawer.style.opacity="1")}};window.addEventListener("pointerdown",event=>{const addButton=event.composedPath().find(node=>node instanceof Element&&node.matches(".product-form__submit"));addButton&&!addButton.disabled&&addButton.closest("quick-add-modal")&&!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections(?:\/|$)/i.test(window.location.pathname)&&(document.documentElement.setAttribute("data-basko-quick-cart-open","true"),bindBaskoCartSlide())},!0),bindBaskoCartSlide(),new MutationObserver(bindBaskoCartSlide).observe(document.documentElement,{subtree:!0,childList:!0});const baskoQuickCartClose=document.createElement("button");baskoQuickCartClose.type="button",baskoQuickCartClose.className="basko-quick-cart-close",baskoQuickCartClose.setAttribute("aria-label","Winkelwagen sluiten"),baskoQuickCartClose.textContent="\xD7",baskoQuickCartClose.addEventListener("click",()=>{document.documentElement.removeAttribute("data-basko-quick-cart-open");const slide=document.querySelector(".xboost-cart-slide");if(slide){delete slide.dataset.baskoQuickCartForced,slide.style.display="none";const drawer=slide.querySelector(".xb-cart-drawer-wrapper");drawer&&(drawer.style.opacity="0")}}),document.body.appendChild(baskoQuickCartClose);
})();
//# sourceMappingURL=/cdn/shop/t/44/assets/quick-add.js.map?v=122258246892078125011788256522

// BASKO collection quick-buy refinements. Product pages and non-collection quick buys are untouched.
(() => {
  const collectionPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections(?:\/|$)/i;
  if (!collectionPath.test(window.location.pathname)) return;

  const modalSelector = 'quick-add-modal';
  const summarySources = new WeakMap();
  const observedPrices = new WeakSet();

  const clearLegacyQuickCartBlock = () => {
    document.documentElement.removeAttribute('data-basko-quick-cart-open');

    const slide = document.querySelector('.xboost-cart-slide');
    if (!slide || slide.dataset.baskoQuickCartForced !== 'true') return;

    delete slide.dataset.baskoQuickCartForced;
    slide.style.removeProperty('display');
    slide.style.removeProperty('z-index');
    slide.style.removeProperty('flex-direction');
    slide.querySelector('.xb-cart-drawer-wrapper')?.style.removeProperty('opacity');
  };

  const releaseQuickBuyAdd = (event) => {
    const addButton = event.composedPath().find((node) => (
      node instanceof Element && node.matches('.product-form__submit')
    ));

    if (addButton?.closest(`${modalSelector}[data-basko-collection-quick-buy]`)) {
      clearLegacyQuickCartBlock();
    }
  };

  const cloneWithoutIds = (source) => {
    const clone = source.cloneNode(true);
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
    return clone;
  };

  const mountMobileSummary = (modal) => {
    const mediaWrapper = modal.querySelector('.product__media-wrapper');
    const infoContainer = modal.querySelector('.product__info-container');
    const title = infoContainer?.querySelector(':scope > .product__title');
    const price = infoContainer?.querySelector(':scope > [id^="price-"]');

    if (!mediaWrapper || !title || !price) return;

    let summary = mediaWrapper.querySelector(':scope > .basko-mobile-quickbuy-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'basko-mobile-quickbuy-summary';
      mediaWrapper.prepend(summary);
    }

    const syncSummary = () => {
      const source = `${title.innerHTML}\u0000${price.innerHTML}`;
      if (summarySources.get(summary) === source) return;

      summarySources.set(summary, source);
      summary.replaceChildren(cloneWithoutIds(title), cloneWithoutIds(price));
    };

    syncSummary();

    if (!observedPrices.has(price)) {
      observedPrices.add(price);
      new MutationObserver(syncSummary).observe(price, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true,
      });
    }
  };

  const markSizeSelectors = (modal) => {
    modal.querySelectorAll('variant-selects fieldset').forEach((fieldset) => {
      const label = fieldset.querySelector('legend')?.textContent?.trim() || '';
      const isColor = /kleur|color|couleur|farbe|colore|cor/i.test(label);
      const isSize = !isColor && /maat|size|jacket|jas|broek|pants|short/i.test(label);
      fieldset.toggleAttribute('data-basko-color-option', isColor);
      fieldset.toggleAttribute('data-basko-size-option', isSize);
    });
  };

  const mountColorSwiper = (modal) => {
    if (window.matchMedia('(max-width: 749px)').matches) return;
    if (!window.Swiper) return;

    modal.querySelectorAll('.ritual-colors-wrapper').forEach((root) => {
      const swiperElement = root.querySelector('.mySwiper');
      const slides = root.querySelectorAll('.mySwiper .swiper-slide');

      if (!swiperElement || slides.length < 2 || swiperElement.classList.contains('swiper-initialized')) {
        return;
      }

      new window.Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 5,
        loop: false,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: root.querySelector('.ritual-next'),
          prevEl: root.querySelector('.ritual-prev'),
        },
      });
    });
  };

  const prepareModal = (modal) => {
    if (!(modal instanceof Element) || !modal.matches(modalSelector)) return;

    modal.setAttribute('data-basko-collection-quick-buy', '');
    mountColorSwiper(modal);
    mountMobileSummary(modal);
    markSizeSelectors(modal);
    window.setTimeout(() => {
      mountColorSwiper(modal);
      mountMobileSummary(modal);
      markSizeSelectors(modal);
    }, 60);
  };

  const scan = (node) => {
    if (!(node instanceof Element)) return;

    const variantFieldset = node.matches('variant-selects, variant-selects fieldset')
      ? node
      : node.querySelector('variant-selects fieldset');
    const variantModal = variantFieldset?.closest(modalSelector);
    if (variantModal) markSizeSelectors(variantModal);

    const containingModal = node.matches(modalSelector)
      ? node
      : node.matches('product-info')
        ? node.closest(modalSelector)
        : null;
    if (containingModal) prepareModal(containingModal);
    node.querySelectorAll(modalSelector).forEach(prepareModal);
  };

  document.querySelectorAll(modalSelector).forEach(prepareModal);
  clearLegacyQuickCartBlock();
  window.addEventListener('pointerdown', releaseQuickBuyAdd, true);
  window.addEventListener('click', releaseQuickBuyAdd, true);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(scan);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* BASKO collection Quick Buy v3: in-place cart, localized details and color switching. */
(() => {
  const collectionPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections(?:\/|$)/i;
  if (!collectionPath.test(window.location.pathname)) return;

  const modalSelector = 'quick-add-modal[data-basko-collection-quick-buy]';
  const mobileColors = window.matchMedia('(max-width: 749px)');
  const locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const copy = {
    de: {
      added: 'Zum Warenkorb hinzugefügt',
      cart: 'Warenkorb',
      colors: 'Alle Farben',
      details: 'Alle Produktdetails ansehen',
      items: 'Artikel',
    },
    en: {
      added: 'Added to cart',
      cart: 'Cart',
      colors: 'All colors',
      details: 'View all product details',
      items: 'items',
    },
    es: {
      added: 'Añadido al carrito',
      cart: 'Carrito',
      colors: 'Todos los colores',
      details: 'Ver todos los detalles del producto',
      items: 'artículos',
    },
    fr: {
      added: 'Ajouté au panier',
      cart: 'Panier',
      colors: 'Toutes les couleurs',
      details: 'Voir tous les détails du produit',
      items: 'articles',
    },
    it: {
      added: 'Aggiunto al carrello',
      cart: 'Carrello',
      colors: 'Tutti i colori',
      details: 'Vedi tutti i dettagli del prodotto',
      items: 'articoli',
    },
    nl: {
      added: 'Toegevoegd aan winkelwagen',
      cart: 'Winkelwagen',
      colors: 'Alle kleuren',
      details: 'Zie alle productdetails',
      items: 'artikelen',
    },
  }[locale] || {
    added: 'Added to cart',
    cart: 'Cart',
    colors: 'All colors',
    details: 'View all product details',
    items: 'items',
  };

  const route = (path) => `${window.Shopify?.routes?.root || '/'}${path}`;

  const quickBuyHTMLCache = new Map();

  const quickBuyHTML = (url) => {
    const key = new URL(url, window.location.href).href;
    if (quickBuyHTMLCache.has(key)) return quickBuyHTMLCache.get(key);

    if (quickBuyHTMLCache.size >= 20) {
      quickBuyHTMLCache.delete(quickBuyHTMLCache.keys().next().value);
    }

    const request = fetch(key, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Unable to load Quick Buy (${response.status})`);
        return response.text();
      })
      .catch((error) => {
        quickBuyHTMLCache.delete(key);
        throw error;
      });

    quickBuyHTMLCache.set(key, request);
    return request;
  };

  const warmQuickBuy = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target?.closest('[data-product-url]');
    if (!trigger?.closest('modal-opener')) return;
    quickBuyHTML(trigger.getAttribute('data-product-url')).catch(() => {});
  };

  ['pointerover', 'pointerdown', 'focusin'].forEach((eventName) => {
    document.addEventListener(eventName, warmQuickBuy, { capture: true, passive: true });
  });

  const warmInitialQuickBuys = () => {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;

    document.querySelectorAll('modal-opener [data-product-url]').forEach((trigger, index) => {
      if (index < 2) quickBuyHTML(trigger.getAttribute('data-product-url')).catch(() => {});
    });
  };

  const scheduleInitialWarmup = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmInitialQuickBuys, { timeout: 1800 });
    } else {
      window.setTimeout(warmInitialQuickBuys, 900);
    }
  };

  if (document.readyState === 'complete') scheduleInitialWarmup();
  else window.addEventListener('load', scheduleInitialWarmup, { once: true });

  const quickAddModalClass = customElements.get('quick-add-modal');
  const quickAddPrototype = quickAddModalClass?.prototype;
  if (quickAddPrototype && !quickAddPrototype.baskoFastShow) {
    const modalDialogShow = Object.getPrototypeOf(quickAddPrototype).show;
    Object.defineProperty(quickAddPrototype, 'baskoFastShow', { value: true });

    quickAddPrototype.show = function showCachedQuickBuy(opener) {
      const productUrl = opener.getAttribute('data-product-url');
      if (!productUrl) return;

      opener.setAttribute('aria-disabled', 'true');
      opener.classList.add('loading');
      opener.querySelector('.loading__spinner')?.classList.remove('hidden');

      quickBuyHTML(productUrl)
        .then((responseText) => {
          const productElement = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector('product-info');
          if (!productElement) throw new Error('Quick Buy product information is unavailable');

          this.preprocessHTML(productElement);
          HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
          window.Shopify?.PaymentButton?.init();
          window.ProductModel?.loadShopifyXR?.();
          modalDialogShow.call(this, opener);
        })
        .catch((error) => console.error('Quick Buy load failed', error))
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading__spinner')?.classList.add('hidden');
        });
    };
  }

  const localizeDetailsLink = (modal) => {
    const link = modal.querySelector('.product__view-details');
    if (!link) return;
    link.setAttribute('data-basko-details-label', copy.details);
    link.setAttribute('aria-label', copy.details);
  };

  const localizeColorTitle = (modal) => {
    const wrapper = modal.querySelector('.ritual-colors-wrapper');
    if (!wrapper) return;
    wrapper.setAttribute('data-basko-colors-label', copy.colors);
  };

  const removeMobileColorSwiper = (modal) => {
    if (!mobileColors.matches) return;

    modal.querySelectorAll('.ritual-colors-wrapper .mySwiper').forEach((swiperElement) => {
      try {
        swiperElement.swiper?.destroy(true, true);
      } catch (error) {
        console.warn('Quick Buy color slider cleanup failed', error);
      }
      swiperElement.setAttribute('data-basko-native-colors', '');
    });
  };

  const prepareModal = (modal) => {
    if (!(modal instanceof Element) || !modal.matches('quick-add-modal')) return;
    modal.setAttribute('data-basko-collection-quick-buy', '');
    localizeDetailsLink(modal);
    localizeColorTitle(modal);
    removeMobileColorSwiper(modal);
    window.setTimeout(() => {
      localizeDetailsLink(modal);
      localizeColorTitle(modal);
      removeMobileColorSwiper(modal);
    }, 80);
  };

  const scan = (node) => {
    if (!(node instanceof Element)) return;
    const modal = node.matches('quick-add-modal')
      ? node
      : node.matches('product-info')
        ? node.closest('quick-add-modal')
        : null;
    if (modal) prepareModal(modal);
    node.querySelectorAll('quick-add-modal').forEach(prepareModal);
  };

  const showAddedState = (cart) => {
    document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"]').forEach((cartLink) => {
      let bubble = cartLink.querySelector('.cart-count-bubble');
      if (!bubble && cart.item_count > 0) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        cartLink.append(bubble);
      }

      if (bubble) {
        const visibleCount = bubble.querySelector('[aria-hidden="true"]') || bubble.querySelector('span');
        if (visibleCount) visibleCount.textContent = cart.item_count;
        const hiddenCount = bubble.querySelector('.visually-hidden');
        if (hiddenCount) hiddenCount.textContent = `${cart.item_count} ${copy.items}`;
        bubble.classList.remove('basko-cart-count-updated');
        window.requestAnimationFrame(() => bubble.classList.add('basko-cart-count-updated'));
      }

      cartLink.setAttribute('aria-label', `${copy.cart} ${cart.item_count} ${copy.items}`);
    });

    let toast = document.querySelector('.basko-quickbuy-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'basko-quickbuy-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.append(toast);
    }

    toast.textContent = copy.added;
    toast.classList.add('is-visible');
    window.clearTimeout(toast.baskoHideTimer);
    toast.baskoHideTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  const showProductError = (modal, message) => {
    const wrapper = modal.querySelector('.product-form__error-message-wrapper');
    const target = wrapper?.querySelector('.product-form__error-message');
    if (target) target.textContent = message;
    if (wrapper) wrapper.hidden = false;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const modal = form.closest(modalSelector);
    if (!modal || !form.closest('product-form')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.baskoSubmitting === 'true') return;

    form.dataset.baskoSubmitting = 'true';
    const button = form.querySelector('[type="submit"]');
    button?.setAttribute('aria-disabled', 'true');
    button?.classList.add('loading');

    try {
      const response = await fetch(window.routes?.cart_add_url || route('cart/add.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(form),
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add this product');
      }

      const cartResponse = await fetch(route('cart.js'), {
        headers: { Accept: 'application/json' },
      });
      const cart = await cartResponse.json();

      modal.hide();
      showAddedState(cart);
    } catch (error) {
      showProductError(modal, error.message);
    } finally {
      delete form.dataset.baskoSubmitting;
      button?.removeAttribute('aria-disabled');
      button?.classList.remove('loading');
    }
  }, true);

  document.addEventListener('click', async (event) => {
    const link = event.target.closest(`${modalSelector} .ritual-colors-wrapper a[href]`);
    if (!link) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const modal = link.closest(modalSelector);
    const targetUrl = new URL(link.href, window.location.href);
    const currentUrl = new URL(modal.querySelector('.product__title a')?.href || window.location.href);
    if (targetUrl.pathname === currentUrl.pathname || modal.dataset.baskoProductLoading === 'true') return;

    modal.dataset.baskoProductLoading = 'true';
    modal.setAttribute('aria-busy', 'true');

    try {
      const productElement = new DOMParser()
        .parseFromString(await quickBuyHTML(targetUrl.href), 'text/html')
        .querySelector('product-info');
      if (!productElement) throw new Error('Selected product information is unavailable');

      modal.preprocessHTML(productElement);
      HTMLUpdateUtility.setInnerHTML(modal.modalContent, productElement.outerHTML);
      const updatedTitle = modal.querySelector('.product__title h2')?.textContent?.trim();
      const colorTitle = modal.querySelector('.ritual-title');
      if (updatedTitle && colorTitle) {
        const colorPrefix = colorTitle.textContent.split(':')[0].trim();
        colorTitle.textContent = `${colorPrefix}: ${updatedTitle}`;
      }
      window.Shopify?.PaymentButton?.init();
      window.ProductModel?.loadShopifyXR?.();
      prepareModal(modal);
    } catch (error) {
      console.error(error);
    } finally {
      delete modal.dataset.baskoProductLoading;
      modal.removeAttribute('aria-busy');
    }
  }, true);

  document.querySelectorAll('quick-add-modal').forEach(prepareModal);
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach(scan));
  }).observe(document.documentElement, { childList: true, subtree: true });

  mobileColors.addEventListener?.('change', () => {
    document.querySelectorAll('quick-add-modal').forEach(prepareModal);
  });
})();
